/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Value_ExpressionInputs */

const cs_field_value_expression = /** @type {(inputs: Field_Value_ExpressionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výraz`)
};

const en_field_value_expression = /** @type {(inputs: Field_Value_ExpressionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expression`)
};

/**
* | output |
* | --- |
* | "Expression" |
*
* @param {Field_Value_ExpressionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_value_expression = /** @type {((inputs?: Field_Value_ExpressionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Value_ExpressionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_value_expression(inputs)
	return cs_field_value_expression(inputs)
});